<template>
  <svg
    class="assistant-module-icon"
    :class="[
      `assistant-module-icon--${kind}`,
      { 'assistant-module-icon--tile': tile },
    ]"
    :width="normalizedSize"
    :height="normalizedSize"
    viewBox="0 0 48 48"
    role="img"
    :aria-label="resolvedLabel"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      v-if="tile"
      class="assistant-module-icon__surface"
      x="3"
      y="3"
      width="42"
      height="42"
      rx="12"
    />

    <g class="assistant-module-icon__mark" :data-kind="kind" aria-hidden="true">
      <template v-if="kind === 'goals'">
        <g data-goal-logo="bullseye" class="goal-logo__bullseye">
          <circle class="assistant-module-icon__field goal-logo__target-base" cx="23" cy="25" r="14.2" />
          <circle class="assistant-module-icon__line goal-logo__target-ring" cx="23" cy="25" r="8.1" />
          <circle class="assistant-module-icon__fill goal-logo__target-core" cx="23" cy="25" r="3.9" />
        </g>
        <g data-goal-logo="arrow" class="assistant-module-icon__accent goal-logo__arrow">
          <path class="goal-logo__arrow-line" d="M38.5 9.5 25.6 22.4" />
          <path class="goal-logo__arrow-head" d="M25.6 22.4 32 21 27 16" />
        </g>
      </template>

      <template v-else-if="kind === 'projects'">
        <path class="assistant-module-icon__field" d="M8 17.2C8 14.9 9.9 13 12.2 13h8.4l3.8 4.2h11.4c2.3 0 4.2 1.9 4.2 4.2v12.4c0 2.3-1.9 4.2-4.2 4.2H12.2C9.9 38 8 36.1 8 33.8V17.2Z" />
        <path class="assistant-module-icon__shade" d="M8 22h32v11.8c0 2.3-1.9 4.2-4.2 4.2H12.2C9.9 38 8 36.1 8 33.8V22Z" />
        <path class="assistant-module-icon__accent" d="M15 28h18M15 33h12" />
      </template>

      <template v-else-if="kind === 'requirements'">
        <rect class="assistant-module-icon__field" x="12" y="8.5" width="24" height="31" rx="5.2" />
        <path class="assistant-module-icon__shade" d="M18 15h12M18 21h10M18 27h12" />
        <path class="assistant-module-icon__accent" d="M18 33.5h5.5l3.3-4.9 3.2 4.9H36" />
      </template>

      <template v-else-if="kind === 'products'">
        <g class="product-assistant-icon__blueprint">
          <path class="assistant-module-icon__accent product-assistant-icon__flow" d="M14 11.5H28.6C32.5 11.5 35.5 14.5 35.5 18.4V35" />
          <circle class="assistant-module-icon__node product-assistant-icon__node" cx="14" cy="11.5" r="3.3" />
          <circle class="assistant-module-icon__node product-assistant-icon__node" cx="35.5" cy="35" r="3.3" />
        </g>
        <g class="product-assistant-icon__cube">
          <path class="assistant-module-icon__field product-assistant-icon__face product-assistant-icon__face--top" d="M24 14.2 36.8 21.4 24 28.6 11.2 21.4 24 14.2Z" />
          <path class="assistant-module-icon__shade product-assistant-icon__face product-assistant-icon__face--left" d="M11.2 21.4 24 28.6V41.2L11.2 34V21.4Z" />
          <path class="assistant-module-icon__fill product-assistant-icon__face product-assistant-icon__face--right" d="M36.8 21.4 24 28.6V41.2L36.8 34V21.4Z" />
          <path class="assistant-module-icon__edge product-assistant-icon__edge" d="M11.2 21.4 24 28.6 36.8 21.4M24 28.6V41.2" />
        </g>
      </template>

      <template v-else-if="kind === 'incidents'">
        <path class="assistant-module-icon__field" d="M24 7.8 41.2 37.6H6.8L24 7.8Z" />
        <path class="assistant-module-icon__accent" d="M24 18.5v9.8" />
        <circle class="assistant-module-icon__fill" cx="24" cy="34" r="2.4" />
      </template>

      <template v-else-if="kind === 'feedback'">
        <path class="assistant-module-icon__field" d="M9 13.5C9 10.7 11.3 8.5 14.1 8.5h19.8c2.8 0 5.1 2.2 5.1 5v14.2c0 2.8-2.3 5.1-5.1 5.1H23.2L13.4 39v-6.2c-2.5-.3-4.4-2.4-4.4-5.1V13.5Z" />
        <path class="assistant-module-icon__shade" d="M16.5 18h15M16.5 24h11" />
        <path class="assistant-module-icon__accent" d="M32.5 28.5 37 33l4.5-7" />
      </template>

      <template v-else-if="kind === 'virtualEmployee'">
        <path class="assistant-module-icon__field" d="M24 7.8c5.1 0 9.2 4.1 9.2 9.2S29.1 26.2 24 26.2 14.8 22.1 14.8 17 18.9 7.8 24 7.8Z" />
        <path class="assistant-module-icon__shade" d="M11 40.2c1.8-7 6.3-10.5 13-10.5s11.2 3.5 13 10.5" />
        <path class="assistant-module-icon__accent" d="M35.5 13.5h4.2M37.6 11.4v4.2M9 25.5h5.2M11.6 22.9v5.2M32.2 29.2l4.6 4.6" />
      </template>

      <template v-else-if="kind === 'collect'">
        <path class="assistant-module-icon__field" d="M10 15.5c0-3.4 6.3-6.2 14-6.2s14 2.8 14 6.2v17c0 3.4-6.3 6.2-14 6.2s-14-2.8-14-6.2v-17Z" />
        <path class="assistant-module-icon__shade" d="M10 15.5c0 3.4 6.3 6.2 14 6.2s14-2.8 14-6.2M10 24c0 3.4 6.3 6.2 14 6.2s14-2.8 14-6.2" />
        <path class="assistant-module-icon__accent" d="M31.5 30.5 37 36l5-8" />
      </template>

      <template v-else>
        <rect class="assistant-module-icon__field" x="8.5" y="8" width="31" height="31" rx="8.5" />
        <path class="assistant-module-icon__shade" d="M16 30.5v-6M24 30.5v-14M32 30.5v-9" />
        <path class="assistant-module-icon__accent" d="M15 36h18M14.5 17.5l6.5 5 6.2-7.4 6.4 4.6" />
      </template>
    </g>
  </svg>
</template>

<script lang="ts">
export const moduleIconKinds = [
  'goals',
  'projects',
  'requirements',
  'products',
  'incidents',
  'feedback',
  'efficiency',
  'virtualEmployee',
  'collect',
] as const

export type ModuleIconKind = typeof moduleIconKinds[number]
</script>

<script setup lang="ts">
import { computed } from 'vue'

const moduleIconLabels: Record<ModuleIconKind, string> = {
  goals: '目标管理助手',
  projects: '项目管理助手',
  requirements: '需求管理助手',
  products: '产品管理助手',
  incidents: '故障管理助手',
  feedback: '反馈助手',
  efficiency: '人效助手',
  virtualEmployee: '虚拟员工',
  collect: '数据采集中心',
}

const props = withDefaults(defineProps<{
  kind: ModuleIconKind
  size?: number | string
  tile?: boolean
  ariaLabel?: string
}>(), {
  size: 24,
  tile: false,
  ariaLabel: undefined,
})

const normalizedSize = computed(() => String(props.size))
const resolvedLabel = computed(() => props.ariaLabel || moduleIconLabels[props.kind])
</script>

<style scoped>
.assistant-module-icon {
  display: inline-block;
  flex-shrink: 0;
  overflow: visible;
  color: var(--tf-primary);
}

.assistant-module-icon--goals {
  color: var(--tf-module-goals);
}

.assistant-module-icon--projects {
  color: var(--tf-module-projects);
}

.assistant-module-icon--requirements {
  color: var(--tf-module-requirements);
}

.assistant-module-icon--products {
  color: var(--tf-module-products);
}

.assistant-module-icon--incidents {
  color: var(--tf-module-incidents);
}

.assistant-module-icon--feedback {
  color: var(--tf-module-feedback, var(--tf-info));
}

.assistant-module-icon--efficiency {
  color: var(--tf-info);
}

.assistant-module-icon--virtualEmployee {
  color: var(--tf-accent);
}

.assistant-module-icon--collect {
  color: var(--tf-info);
}

.assistant-module-icon__surface {
  fill: color-mix(in srgb, currentColor 10%, var(--tf-bg-card));
  stroke: color-mix(in srgb, currentColor 20%, var(--tf-border));
  stroke-width: 1.4;
}

.assistant-module-icon__field {
  fill: color-mix(in srgb, currentColor 15%, var(--tf-bg-card));
  stroke: currentColor;
  stroke-linejoin: round;
  stroke-width: 2.8;
}

.assistant-module-icon__shade {
  fill: none;
  stroke: color-mix(in srgb, currentColor 68%, var(--tf-bg-card));
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2.8;
}

.assistant-module-icon__line {
  fill: none;
  stroke: currentColor;
  stroke-width: 3.2;
}

.assistant-module-icon__fill {
  fill: currentColor;
}

.assistant-module-icon__accent {
  fill: none;
  stroke: color-mix(in srgb, currentColor 78%, var(--tf-text-primary));
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 3.1;
}

.assistant-module-icon__node {
  fill: var(--tf-bg-card);
  stroke: currentColor;
  stroke-width: 2.6;
}

.assistant-module-icon__edge {
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2.8;
}

.assistant-module-icon--goals .assistant-module-icon__field {
  fill: var(--tf-bg-card);
  stroke: var(--tf-danger);
}

.assistant-module-icon--goals .assistant-module-icon__line {
  stroke: var(--tf-danger);
}

.assistant-module-icon--goals .assistant-module-icon__fill {
  fill: var(--tf-danger);
}

.assistant-module-icon--goals .assistant-module-icon__accent {
  stroke: var(--tf-module-goals);
  stroke-width: 3.4;
}

.product-assistant-icon__flow {
  stroke: color-mix(in srgb, currentColor 38%, transparent);
}
</style>
